import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { TE } from 'appconstants';
import { Protocol } from 'appconstants/ProtocolConstants';
import { connect } from 'react-redux';
import { Route, Switch, useLocation } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import molecules from 'ctsutheme/components/molecules';
import atoms from 'ctsutheme/components/atoms';
import { withAppContext } from '@ctsu/loader';
import { NoMatch } from 'components';
import {
  getCountries, getAllSites, setUserPreferenceByKey
} from 'actions/common';
import { bindLogger } from 'helpers/BindLogger';
import { StickyContainer, Sticky } from 'react-sticky';
import { getSessionByKey, setSessionForKey, getDecodedQueryParams, getEncodedQueryParams } from 'helpers';
import { FasRedoAlt } from 'assets/icons';
import {
  ProtocolTileContent,
  ProtocolHomeContent,
  ProtocolContent,
  ProtocolHeader,
  ProtocolActions,
  ProtocolSections
} from './components';


const { Card, CardHeader } = molecules;
const { Typography, IconButton, Tooltip } = atoms;

const styles = theme => ({
  cardRoot: {
    minHeight: '85vh',
    margin: '5px'
  },
  cardActions: {
    paddingRight: 10,
    paddingTop: 10
  }
});


const withConnectState = connect(
  (state, ownProps) => ({}),
  dispatch => bindActionCreators(
    {
      onGetCountries: getCountries,
      onGetAllSites: getAllSites,
      onSetUserPreference: setUserPreferenceByKey
    },
    dispatch
  )
);

const GridDirections = {
  Right: 'row-reverse',
  Left: 'row',
  Top: 'column',
  Bottom: 'column-reverse'
};

const PrtContentContainer = props => {
  const [state, setState] = useState({
    splitScreen: false,
    selectedGridDirection: 'Left'
  });
  const [prtType, setPrtType] = useState();
  const {
    classes,
    history,
    onGetCountries,
    onGetAllSites,
    onSetUserPreference,
    context,
    type,
    id
  } = props;

  useEffect(() => {
    bindLogger(onGetCountries, context)();
    bindLogger(onGetAllSites, context)();
  }, [context, onGetCountries, onGetAllSites]);
  useEffect(() => {
    if (type != null) {
      setPrtType(Protocol[type]);
    }
  }, [type]);

  const onArrowClick = selectedGridDirection => {
    if (state.splitScreen) {
      setState({
        ...state,
        selectedGridDirection
      });
    }
  };

  const toggleSplitScreen = () => {
    setState({ ...state, splitScreen: !state.splitScreen });
  };

  useEffect(() => {
    const userPref = getSessionByKey('user_recent_protocols');
    const recentProt = userPref ? JSON.parse(userPref) : [];

    if (!recentProt.includes(id)) {
      recentProt.push(id);
      setSessionForKey('user_recent_protocols', JSON.stringify(recentProt));
      bindLogger(onSetUserPreference, context)('UserSelProtocols', JSON.stringify(recentProt));
    }
  }, [
    onSetUserPreference,
    id,
    context
  ]);

  const {
    splitScreen,
    selectedGridDirection
  } = state;

  if (Object.keys(Protocol).indexOf(type) === -1) {
    return (<NoMatch />);
  }

  return (
    <StickyContainer>
      <div id="skip">
        <a href="#sidenavigation">Skip to Side Navigation</a>
      </div>
      <Sticky>
        {({ style, isSticky }) => (
          <div style={{ ...style, zIndex: 1 }} data-sticky={isSticky} className="protocol-sticky">
            <ProtocolHeader isSticky={isSticky} {...props} />
          </div>
        )}
      </Sticky>
      <Grid container spacing={4}>
        <Grid item xs={11} className="app-main-content app-left-content">
          <Card className={classes.cardRoot}>
            <CardHeader
              className="protocol-card-header"
              title={(
                <div data-id={`${TE.ID}${prtType?.title.split(' ').join('_').toLowerCase()}`}>
                  {prtType?.title}
                  <Tooltip
                    tooltipplacementbottom="true"
                    title="Refresh"
                    aria-label="Refresh"
                    style={{ display: 'inline-flex' }}
                  >
                    <Typography component="span" inline link icon>
                      <IconButton
                        aria-label="Refresh Summary"
                        color="inherit"
                        data-id="refreshSummary"
                        onClick={() => history.go(0)}
                        style={{ marginLeft: '.1rem' }}
                      >
                        <FasRedoAlt />
                      </IconButton>
                    </Typography>
                  </Tooltip>

                </div>
              )}
              action={(
                <ProtocolActions
                  splitScreen={splitScreen}
                  selectedGridDirection={selectedGridDirection}
                  onArrowClick={onArrowClick}
                  toggleSplitScreen={toggleSplitScreen}
                />
              )}
            />
            <div
              className={GridDirections[selectedGridDirection]}
              style={{
                display: 'flex',
                flexDirection: GridDirections[selectedGridDirection]
              }}
            >
              <div className="split-screen-flex">
                <ProtocolContent {...props} />
              </div>
              {splitScreen && (
                <div className="split-screen-flex">
                  <ProtocolTileContent {...props} />
                </div>
              )}
            </div>
          </Card>
        </Grid>
        <Grid item xs={1} className="app-right-nav">
          <main id="sidenavigation" tabIndex="-1" />
          <ProtocolSections id={id} {...props} type={type} />
        </Grid>
      </Grid>
    </StickyContainer>
  );
};

const ProtocolContentContainer = withStyles(styles)(
  compose(
    withConnectState,
    withAppContext
  )(PrtContentContainer)
);

export const ProtocolBaseContentContainer = (props) => {
  const {
    match
  } = props;
  const [queryUrl, setQueryUrl] = useState();
  const [isUrlProper, setIsUrlProper] = useState(true);
  
  useEffect(() => {
    const decodeVal = getDecodedQueryParams(match.params.query);
    if (decodeVal.indexOf('/') > -1) {
      const idArr = decodeVal.split('/');
      const type = idArr.splice(idArr.length - 1);
      setQueryUrl({
        id: idArr?.join('/'),
        type: type[0]
      })
    } else {
      setIsUrlProper(false);
    }

  }, [match.params.query]);

  const typeVals = Object.keys(Protocol);
  return (
    <>
      {
        isUrlProper ? (typeVals.indexOf(queryUrl?.type) > -1 && (
          <ProtocolContentContainer {...props} id={queryUrl?.id} type={queryUrl?.type} />
        )) : (<NoMatch />)
      }
    </>
  );
};

export const ProtocolsContainer = ({ match, history }) => {
  const location = useLocation();
 
  useEffect(() => {
    const { pathname } = location;
    const urlParams = pathname.split('/');

    // if url is already encrypted then length will be 3 else 4.
    // if url is not encrypted then encrypt the url and pass
    // else pass the same url
    if(urlParams.length === 4) {
      const encodedUrl = getEncodedQueryParams('/protocol/',`${urlParams[2]}/${urlParams[3]}`)
      history.push(encodedUrl);
    }
  })

  return (
    <Switch>
      <Route
        exact
        path={`${match.url}`}
        component={ProtocolHomeContent}
      />
      <Route
        exact
        path={`${match.url}/:query`}
        component={ProtocolBaseContentContainer}
      />
    </Switch>
  )
};
